import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

function ConfirmModal({
  type = "approve", // "approve" or "reject"
  show,
  handleClose,
  onConfirm
}) {
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");
  const isReject = type === "reject";

  const handleConfirm = () => {
    if (isReject && remark.trim() === "") {
      setError("Remark is required.");
      return;
    }
    setError("");
    onConfirm(remark);
    handleClose();
    setRemark(""); // reset after close
  };

  return (
    <Modal show={show} onHide={handleClose} centered  >
      <div className="p-3 ">
        <div >
          <div className="d-flex ">
            <div>
              <span
                className={`me-2 rounded d-flex justify-content-center align-items-center `}
                style={{
                  width: "60px",
                  height: "55px",
                  backgroundColor: isReject ? "#fdecea" : "#eafaf1",
                  color: isReject ? "#d93025" : "#1e8e3e",
                  fontSize: "20px",
                }}
              >
                {isReject ? "✖" : "✔"}
              </span>
            </div>
            <div>
              <div className="" style={{ fontSize: "20px", fontWeight: "500", color: "#000000" }}>
                {isReject ? "Reject Request" : "Approve Request"}

                {isReject ? (<p style={{ fontSize: "14px", fontWeight: "400", color: "#6B7280" }}>
                  You've rejected this request. Please add a remark so the user understands the reason.
                </p>) : (<p style={{ fontSize: "14px", fontWeight: "400", color: "#6B7280" }}>
                  Are you sure you want to Approve Request?
                </p>)}

              </div>
            </div>
          </div>
        </div>

        <div className="py-0" style={{ paddingTop: "0px" }}>
          {isReject ? (
            <>
              <Form.Group>
                <div style={{ color: "#000000" }}>
                  Add Remark <span style={{ color: "red" }}>*</span>
                </div>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter your remark..."
                  value={remark}
                  onChange={(e) => {
                    setRemark(e.target.value);
                    if (error) setError("");
                  }}
                  isInvalid={!!error}
                />
                <Form.Control.Feedback type="invalid">
                  {error}
                </Form.Control.Feedback>
              </Form.Group>
            </>
          ) : (
            ""
          )}
        </div>

        <div className="d-flex justify-content-end border-0 gap-3 mt-4">
          <Button style={{ backgroundColor: "#FFFFFF", color: "#4B5563", borderColor: "#D1D5DB", padding: "8px 16px" }} onClick={handleClose}>
            Go Back
          </Button>
          <Button
            style={{
              backgroundColor: isReject ? "#C62828" : "#4AA564",
              border: "none",
              padding: "8px 16px"
            }}
            onClick={handleConfirm}
          >
            {isReject ? "Yes, Reject" : "Yes, Approve"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmModal;
